import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import rightArrow from '../../images/arrow-right-blue-textlink.svg';
import '../../sass/components/flexibleModules/_components.genericTabBasedComponent.scss';
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"

const GenericTabBasedComponent = ({ data }) => {

    const [tabSectionVal, setTabSection] = useState(data.genericTabBasedSectionTabs[0].tabName);

    const tabFilter = (tabValue) => {
        setTabSection(tabValue);
    }

    let mediaQueryMax = null;
    let mediaQueryMin = null;
    if (typeof window !== "undefined") {
        mediaQueryMax = window.matchMedia("(max-width: 1100px)");
        mediaQueryMin = window.matchMedia("(min-width: 1101px)");
    }

    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
    }, [isRendered]);

    return (
        <div className="cp-genericTabBasedComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericTabBasedComponent__inner" data-sal="slide-up" data-sal-duration="800" data-sal-easing="ease" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.genericTabBasedSectionHeader &&
                    <h2>{data.genericTabBasedSectionHeader}</h2>
                }
                {data.genericTabBasedSectionTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.genericTabBasedSectionTeaser }} />
                }
                {data.genericTabBasedSectionTabs &&
                    <>
                        <div className="cp-genericTabBasedComponent__grid l--flex">
                            {typeof window !== "undefined" &&
                                <>
                                    {mediaQueryMax.matches ?
                                        <>
                                            {isRendered &&
                                                <Slider {...settings}>
                                                    {data.genericTabBasedSectionTabs.map((tabSection, index) => (
                                                        <React.Fragment key={index}>
                                                            <button className={`l--flex ${tabSection.tabName === tabSectionVal ? 'is-active l--flex' : 'l--flex'}`} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tabSection.tabName}>
                                                                {tabSection.tabIcon &&
                                                                    <img src={tabSection.tabIcon.sourceUrl} alt={tabSection.tabIcon.altText} />
                                                                }
                                                                {tabSection.tabName &&
                                                                    <span>{tabSection.tabName}</span>
                                                                }
                                                            </button>
                                                        </React.Fragment>
                                                    ))}
                                                </Slider>
                                            }
                                        </>
                                        :
                                        <>
                                            {data.genericTabBasedSectionTabs.map((tabSection, index) => (
                                                <button key={index} className={tabSection.tabName === tabSectionVal ? 'is-active l--flex' : 'l--flex'} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tabSection.tabName}>
                                                    {tabSection.tabIcon &&
                                                        <img src={tabSection.tabIcon.sourceUrl} alt={tabSection.tabIcon.altText} />
                                                    }
                                                    {tabSection.tabName &&
                                                        <span>{tabSection.tabName}</span>
                                                    }
                                                </button>
                                            ))}
                                        </>
                                    }
                                </>
                            }

                        </div>
                        <div className="cp-genericTabBasedComponent__gridContent">
                            {data.genericTabBasedSectionTabs.map((tabSection, index) => (
                                <React.Fragment key={index}>
                                    {tabSectionVal === tabSection.tabName &&
                                        <div className="cp-tabSectionHalf l--flex">
                                            <div className="cp-tabSectionHalf__left">
                                                {tabSection.tabHeader &&
                                                    <h2>{tabSection.tabHeader}</h2>
                                                }
                                                {tabSection.tabTeaser &&
                                                    <div dangerouslySetInnerHTML={{ __html: tabSection.tabTeaser }} />
                                                }
                                                {tabSection.tabLink &&
                                                    <a className="l-textlink" href={tabSection.tabLink.url} target={tabSection.tabLink.target}>
                                                        <span>{tabSection.tabLink.title ? tabSection.tabLink.title : "Get a Demo"}</span>
                                                        <img src={rightArrow} alt="" />
                                                    </a>
                                                }
                                                {tabSection.tabGrid &&
                                                    <div className="cp-tabSectionHalf__grid l--flex">
                                                        {tabSection.tabGrid.map((gridItems, index) => (
                                                            <>
                                                                {gridItems.link ?
                                                                    <a href={gridItems.link.url} target={gridItems.link.target} className="cp-tabSectionHalf__grid-section" key={index}>
                                                                        {gridItems.link &&
                                                                            <span className="l--flex">
                                                                                <span>{gridItems.link.title}</span>
                                                                                <StaticImage src="../../images/arrow-right.svg" alt="" />
                                                                            </span>
                                                                        }
                                                                        {gridItems.teaser &&
                                                                            <p dangerouslySetInnerHTML={{ __html: gridItems.teaser }} />
                                                                        }
                                                                    </a>
                                                                    :
                                                                    <div className="cp-tabSectionHalf__grid-section" key={index}>
                                                                        {gridItems.link &&
                                                                            <span className="l--flex">
                                                                                <span>{gridItems.link.title}</span>
                                                                                <StaticImage src="../../images/arrow-right.svg" alt="" />
                                                                            </span>
                                                                        }
                                                                        {gridItems.teaser &&
                                                                            <p dangerouslySetInnerHTML={{ __html: gridItems.teaser }} />
                                                                        }
                                                                    </div>
                                                                }
                                                            </>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                            <div className="cp-tabSectionHalf__right">
                                                {tabSection.tabImage &&
                                                    <GatsbyImage image={getImage(tabSection.tabImage)} alt={tabSection.tabImage.altText} />
                                                }
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                    </>
                }
            </div>
        </div>
    );
}

export default GenericTabBasedComponent;